import { jsx as _jsx } from "react/jsx-runtime";
import { separateReactNodes } from 'utils/react';
import { convertTreeToFlatItems } from 'utils/tree';
const defaultConfig = {
    pathSeparator: ' / ',
};
/**
 * Gets the display value of a custom select field value.
 *
 * @param customField The custom select field.
 * @param config The configuration object.
 */
export function getCustomSelectFieldDisplayValue(customField, config) {
    const { attribute, value } = customField;
    const mergedConfig = Object.assign({}, defaultConfig, config);
    if (!value) {
        return;
    }
    const flatOptions = convertTreeToFlatItems(attribute.options, {
        childrenKey: 'options',
    });
    const separator = (_jsx("span", Object.assign({ className: mergedConfig.separatorClassName }, { children: " / " })));
    const labelPath = value.value
        .map((value) => { var _a; return (_a = flatOptions.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label; })
        .filter(Boolean);
    const nodeTransformFn = (node, index, nodes) => index === nodes.length - 1 ? (_jsx("span", Object.assign({ className: mergedConfig.leafClassName }, { children: node }), index)) : (_jsx("span", Object.assign({ className: mergedConfig.nodeClassName }, { children: node }), index));
    const isLongPath = labelPath.length > 3;
    return {
        isLongPath,
        rawPath: separateReactNodes(labelPath, {
            separator: mergedConfig.pathSeparator,
        }),
        path: isLongPath
            ? separateReactNodes([labelPath[0], '…', labelPath[labelPath.length - 1]], {
                separator,
                nodeTransformFn,
            })
            : separateReactNodes(labelPath, {
                separator: mergedConfig.pathSeparator,
                nodeTransformFn,
            }),
    };
}
